import { LangText } from '@/components'
import { preFixImgUrl } from '@/utils'

const HeroBanner = () => (
  <section
    className="h-[320px] w-full bg-cover bg-center bg-no-repeat"
    style={{
      backgroundImage: `url(${preFixImgUrl('https://static.xyb2b.com/images/bb7d962418493840cece300c31003a37.png')})`,
    }}
  >
    <div className="mx-auto flex h-full w-[1200px] flex-col justify-center text-white">
      <LangText
        lngKey="coupon.hero.title"
        className="font-smiley-sans text-[40px] font-bold leading-[48px]"
      />
      <LangText
        lngKey="coupon.hero.description"
        className="mt-[16px] text-[20px] leading-[28px] text-white/80"
      />
    </div>
  </section>
)

export default HeroBanner
